/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * B2B Backend API
 * API documentation for B2B Platform
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import type {
  ClassificationRun,
  CorrectRunRequest,
  HscodesModeratorRunsRetrieveParams,
  PaginatedClassificationRun
} from '.././model'
import { customInstance } from '../../../../api/client';



/**
 * Every classification with its inputs, votes, result, the code the requester picked and any correction. Filters: `status`, `corrected` (true/false), `source`.
 * @summary Classifier runs (moderator)
 */
export const hscodesModeratorRunsRetrieve = (
    params?: HscodesModeratorRunsRetrieveParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<PaginatedClassificationRun>(
      {url: `/api/v1/hscodes/moderator/runs/`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getHscodesModeratorRunsRetrieveQueryKey = (params?: HscodesModeratorRunsRetrieveParams,) => {
    return [`/api/v1/hscodes/moderator/runs/`, ...(params ? [params]: [])] as const;
    }

    
export const getHscodesModeratorRunsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof hscodesModeratorRunsRetrieve>>, TError = unknown>(params?: HscodesModeratorRunsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hscodesModeratorRunsRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHscodesModeratorRunsRetrieveQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof hscodesModeratorRunsRetrieve>>> = ({ signal }) => hscodesModeratorRunsRetrieve(params, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 30000, gcTime: 300000, refetchOnMount: true,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hscodesModeratorRunsRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type HscodesModeratorRunsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof hscodesModeratorRunsRetrieve>>>
export type HscodesModeratorRunsRetrieveQueryError = unknown

/**
 * @summary Classifier runs (moderator)
 */
export const useHscodesModeratorRunsRetrieve = <TData = Awaited<ReturnType<typeof hscodesModeratorRunsRetrieve>>, TError = unknown>(
 params?: HscodesModeratorRunsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hscodesModeratorRunsRetrieve>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getHscodesModeratorRunsRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Record the right code for this run's product (send the result's own code to confirm it). Corrected runs become precedents for similar product names and labelled data for `manage.py evaluate_hs_classifier`. The code must be in the current HS edition.
 * @summary Correct or confirm a classifier run (moderator)
 */
export const hscodesModeratorRunsCorrectCreate = (
    id: number,
    correctRunRequest: CorrectRunRequest,
 ) => {
      
      
      return customInstance<ClassificationRun>(
      {url: `/api/v1/hscodes/moderator/runs/${id}/correct/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: correctRunRequest
    },
      );
    }
  


export const getHscodesModeratorRunsCorrectCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hscodesModeratorRunsCorrectCreate>>, TError,{id: number;data: CorrectRunRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof hscodesModeratorRunsCorrectCreate>>, TError,{id: number;data: CorrectRunRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof hscodesModeratorRunsCorrectCreate>>, {id: number;data: CorrectRunRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  hscodesModeratorRunsCorrectCreate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type HscodesModeratorRunsCorrectCreateMutationResult = NonNullable<Awaited<ReturnType<typeof hscodesModeratorRunsCorrectCreate>>>
    export type HscodesModeratorRunsCorrectCreateMutationBody = CorrectRunRequest
    export type HscodesModeratorRunsCorrectCreateMutationError = void

    /**
 * @summary Correct or confirm a classifier run (moderator)
 */
export const useHscodesModeratorRunsCorrectCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hscodesModeratorRunsCorrectCreate>>, TError,{id: number;data: CorrectRunRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof hscodesModeratorRunsCorrectCreate>>,
        TError,
        {id: number;data: CorrectRunRequest},
        TContext
      > => {

      const mutationOptions = getHscodesModeratorRunsCorrectCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    